module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":{"doneRestore":"Restored!"}},"ja":{"message":{"doneRestore":"復元しました。"}}}')
  delete Component.options._Ctor
}
